<template>
  <div class="LikeButton">
    <button
      type="button"
      class="LikeButton__trigger"
      :aria-pressed="likeId > 0"
      :aria-label="
        likeId > 0 ? t('common.likeButton.ariaRemoveFavorite') : t('common.likeButton.ariaAddFavorite')
      "
      @click.stop.prevent="switchLike()"
    >
      <Icon :icon="likeId > 0 ? 'mdi:heart' : 'mdi:heart-outline'" color="main-blue" :size="22" />
    </button>
    <span class="LikeButton__count" v-if="count > 0">{{ count }}</span>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/ui/Icon.vue'
import { useApplicationStore } from '@/stores/applicationStore'
import { useUserStore } from '@/stores/userStore'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps<{
  id: string
}>()
const appStore = useApplicationStore()
const userStore = useUserStore()

const likeId = computed(() => appStore.likesList?.[props.id]?.likeId || 0)
const count = computed(() => appStore.likesList?.[props.id]?.count || 0)

function switchLike() {
  if (userStore.userIsLogged) {
    const newLike = likeId.value === 0
    if (newLike) {
      appStore.addLike(props.id)
    } else {
      appStore.deleteLike(likeId.value)
    }
  }
}
</script>

<style lang="scss">
.LikeButton {
  display: flex;
  align-items: center;

  .LikeButton__trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.35rem;
    border: none;
    border-radius: 8px;
    background: transparent;
    cursor: pointer;
    color: rgb(var(--v-theme-main-blue));
    transition: background 0.2s ease;

    &:hover {
      background: rgba(var(--v-theme-main-blue), 0.08);
    }
  }

  .LikeButton__count {
    color: rgb(var(--v-theme-main-blue));
    font-size: var(--font-size-sm, 0.8125rem);
  }
}
</style>
